<!-- [ngClass]="{'gap':actionSectedFormControl.value && actionSectedFormControl.value !=='conv_create_new_response'}" -->
<div class="d-flex gap-12">
    <div class="w-100">
        <mat-select [errorStateMatcher]="matcher" [formControl]="actionSectedFormControl"
            placeholder="choose a response" (selectionChange)="selectResponse($event)" required>
            <mat-option *ngIf="!built" value="conv_create_new_response" class="create-new-option" disableRipple>
<div class="button-content">
        <span class="create-new-text">Create new response</span>
    </div>
            </mat-option>
            <mat-option *ngFor="let action of actionsListResponse" [value]="action.id">
                {{action.name}}
            </mat-option>
        </mat-select>

    </div>

    <div class="btn-default"
        *ngIf="actionSectedFormControl.value && actionSectedFormControl.value !== 'conv_create_new_response'">
        <button (click)="goToActionEdit(built, actionSectedFormControl.value)">
            Edit response
        </button>
    </div>
</div>